export default __webpack_public_path__ + "static/media/java.b7744fb5.png";